<template>
	<div class="num-box">
		<div class="roll-num" v-for="(item,index) in page_count" :key="index">
			<span class="num" :style="transform1" ref="numberItem" v-if="!isNaN(item)">0123456789</span>
			<span v-else>{{item}}</span>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'RollNum',
		props: {
			count: Number
		},
		data() {
			return {
				transform1: "",
				page_count: []
			}
		},
		mounted() {
			this.increaseNumber();
		},
		watch: {
			count: {
				handler(newName, oldName) {
					//页面每隔十秒会传输数据过来，会立即监听到newName, oldName后不要着急赋值page_count，延迟一秒，避免数字位数错乱（从1位突然变成2位）
					// console.log('page_count changed', newName, oldName);
					setTimeout(() => {
						this.page_count = JSON.stringify(newName).split('');
					}, 1000);
					// console.log(this.page_count);
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			increaseNumber() {
				let self = this;
				self.page_count = JSON.stringify(self.count).split('');
				this.timer = setInterval(() => {
					self.newNumber = self.newNumber + self.getRandomNumber(1, 10)
					self.setNumberTransform()
				}, 0)
			},
			// 设置每一位数字的偏移
			setNumberTransform() {
				let numberItems = this.$refs.numberItem
				let numberArr = this.page_count.filter(item => !isNaN(item))
				for (let index = 0; index < numberItems.length; index++) {
					let elem = numberItems[index]
					elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
				}
			},
			//0-9之间随机一个数出来
			getRandomNumber(min, max) {
				return Math.floor(Math.random() * (max - min + 1) + min)
			}
		},
	}
</script>

<style lang="scss" scoped>
	.num-box {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.roll-num {
		position: relative;
		writing-mode: vertical-lr;
		text-orientation: upright;
		width: 16px;
		height: 30px;
		text-align: center;
		overflow: hidden;

		.num {
			position: absolute;
			top: 4px;
			left: 50%;
			transform: translateX(-50%);
			letter-spacing: 10px;
			transition: transform 0.5s ease-in-out;
		}
	}
</style>
